import { HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { LANGUAGE_KEY } from '../constants/languages.const';

export function urlInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> {
  // Skip i18n requests
  if (req.url.startsWith('resources/i18n')) {
    return next(req);
  }

  const language = localStorage.getItem(LANGUAGE_KEY) || 'en';

  req = req.clone({
    url: environment.api.url.concat(req.url),
    setParams: {
      culture: language,
    },
  });

  return next(req);
}
